import React, {useEffect, useState, ChangeEvent, KeyboardEvent} from 'react';
//import React, {useState} from 'react';
import api from 'api';

const PosContentUserInfo = (u) => {

  console.log("userInfo", u);
  console.log("u.userIdx", u.u.userIdx);
/*
  const apiUrl = "http://" + window.location.hostname + ":18080"

  const [userInfo, setUserInfo] = useState({
    userIdx: 0,
    userCode: '',
    userGrade: '',
    userNickname: '',
    userType: '',
    userPoint: 0,
    userAttendance: 0,
    userPurchase: 0
  });


  const getUserInfo = async (e) => {
    const { value, name } = e.target;
    setUserInfo({...userInfo, [name]: value});
    console.log('userInfo.userCode', userInfo.userCode);
    if(value === ""){ alert("유저코드를 입력 해 주세요"); return; }

    try {
      const response = await api.get(apiUrl + '/user/' + value);
      const resp = response;
      if(resp === ""){ alert("존재하지 않는 유저입니다."); return; }
      setUserInfo({...resp});
    } catch (error) {
      console.error('사용자 정보 조회 실패:', error);
      alert('사용자 정보 조회 중 오류가 발생했습니다.');
    }
  }

  const getUserInfoEnter = (e) => {
    if(e.key === 'Enter') {
      getUserInfo(e);
    }
  }
*/
  useEffect(() => {
    //getProductList();
    //getUserInfo();
  }, []);

    if(u.u.userIdx === 0){
      return (
        <>
        <h5 className="card-title">회원정보</h5>
        <div className="row mb-3">
          {/*<div className="col-sm-8">
            <input 
              type="text" 
              className="form-control" 
              value={value} 
              name="userCode" 
              onChange={(e) => { setValue(e.target.value); }} 
              onKeyDown={getUserInfoEnter}
              placeholder="회원코드" 
              list="userCodeList"
            />
          </div>
          <div className="col-sm-4">
            <button type="button" className="btn btn-primary" onClick={getUserInfo}>입력</button>
          </div>*/}
          <div className="col-sm-12">
            검색된 회원정보가 없습니다.
          </div>
        </div>
        </>
      );
    }else{
      return (
        <>
        <h5 className="card-title">{u.u.userNickname}님 ({u.u.userGrade})</h5>
        <div className="row mb-3">
          <div>
            {/*누적구매: {u.userPurchase.toLocaleString('ko-KR')}엔&nbsp;&nbsp;&nbsp;&nbsp;현재 포인트: {u.userPoint}&nbsp;&nbsp;&nbsp;&nbsp;출석: {u.userAttendance}회*/}
            누적구매: {u.u.userPurchase}엔&nbsp;&nbsp;&nbsp;&nbsp;현재 포인트: {u.u.userPoint}&nbsp;&nbsp;&nbsp;&nbsp;출석: {u.u.userAttendance}회
          </div>
        </div>
        </>
      );
    }

}


export default PosContentUserInfo;